import type { TableColumn } from "rujira.ui";

export const COLLATERAL_LOGOS = {
  single: 2,
  multiple: 1.75,
  overlap: 0.375,
} as const;

type CollateralGroup = {
  collaterals: readonly { collateral: { __typename: string } }[];
};

export const collateralLogoColumnWidth = (
  accounts: readonly CollateralGroup[]
) => {
  // Single logos are 2rem; multiple logos are 1.75rem with 0.375rem overlap.
  const footprint = accounts.reduce<number>((largest, account) => {
    const count = account.collaterals.filter(
      ({ collateral }) => collateral.__typename === "Balance"
    ).length;
    const width =
      count > 1
        ? count * COLLATERAL_LOGOS.multiple -
          (count - 1) * COLLATERAL_LOGOS.overlap
        : COLLATERAL_LOGOS.single;
    return Math.max(largest, width);
  }, COLLATERAL_LOGOS.single);
  return footprint + 0.25;
};

export const getCollateralTableColumns = (
  columns: readonly TableColumn[],
  accounts: readonly CollateralGroup[]
): TableColumn[] => {
  const logoWidth = collateralLogoColumnWidth(accounts);
  return columns.map((column) => {
    if (column.id === "logo") return { ...column, width: logoWidth + "rem" };
    if (column.id === "action") {
      return { ...column, width: column.minWidth ?? column.width };
    }
    return { ...column, width: "auto" };
  });
};
